import { Virtuoso } from "react-virtuoso";
import { ConceptView } from "./ConceptView";
import { Concept } from "../Types";
import { useState } from "react";
import { AddButton } from "./AddButton";

const ConceptCard = (_index: number, data: Concept, context: any) => {
  const {
    pack,
    getSelectedElement,
    selection,
    setSelection,
    selectedColsNonControls,
    updateRepField,
    ...otherProps
  } = context;

  // @ts-ignore we have it
  const conceptIndex = data.index;
  const c = data;

  // TODO callbackify
  const setSelectionFromConcept = (
    repIndex: number,
    repKeyIndex: number,
  ) => {
    setSelection(conceptIndex, repIndex, repKeyIndex);
  };
  const getSelectedElementFromConcept = (
    repIndex: number,
    repKeyIndex: number,
  ) => {
    return getSelectedElement(conceptIndex, repIndex, repKeyIndex);
  };

  const selected = selection[0] === conceptIndex;

  return ( // @ts-ignore otherprops has it
    <ConceptView
      key={c.id}
      index={conceptIndex}
      selected={selected}
      selectedCols={selectedColsNonControls}
      selection={selected ? selection as [number, number, number] : undefined}
      setSelection={setSelectionFromConcept}
      getSelectedElement={getSelectedElementFromConcept}
      concept={c}
      reps={pack.data.reps}
      isSuggested={c.id === "SUGGESTED"}
      updateRepField={updateRepField}
      packEditorCallbacks={otherProps.packEditorCallbacks}
      {...otherProps}
    /> // style={styles}
  );
};

export const AllConceptsView = (props) => {
  const {
    scrollRef,
    concepts,
    addConceptCbWrapper,
    selection,
    pack,
    getSelectedElement,
    setSelection,
    selectedColsNonControls,
    updateRepField,
    ...otherProps
  } = props;

  const [searchText, setSearchText] = useState<string>("");

  const conceptsWithIndex = concepts.map(
    (c, index) => ({ ...c, index } as Concept),
  );

  const filteredConcepts = searchText != ""
    ? conceptsWithIndex.filter(
      (c) =>
        c.id?.toLowerCase().includes(searchText.toLowerCase()) ||
        Object.keys(c.reps).some(
          (repKey) =>
            c.reps[repKey]?.text?.toLowerCase()?.includes(
              searchText.toLowerCase(),
            ),
        ),
    )
    : conceptsWithIndex;

  return (
    <>
      <div className="section">💡 concepts</div>
      {/* search bar */}
      <div className="search">
        <input
          type="text"
          placeholder="search"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>
      <div className="concepts">
        <Virtuoso
          ref={scrollRef}
          // Window height
          height={window.innerHeight - 200}
          style={{
            margin: "0 auto",
            border: "1px solid #ccc",
            borderRadius: "5px",
            width: "95vw",
            height: "60vh",
          }}
          totalCount={filteredConcepts.length}
          itemContent={ConceptCard}
          data={filteredConcepts}
          context={{
            pack,
            getSelectedElement,
            selection,
            setSelection,
            selectedColsNonControls,
            updateRepField,
            ...otherProps,
          }}
          // itemSize={itemSize}
          // Window width
          width={window.innerWidth}
        />
      </div>
      <AddButton
        selected={selection[0] === concepts.length}
        onClick={addConceptCbWrapper}
        title="add concept"
      />
    </>
  );
};
